import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = StyleSheet.create({
  price: {
    ...Fonts.type.bold,
    fontSize: 25,
  },
  upfront: {
    fontSize: 18.7,
    marginRight: 20,
    marginTop: 4,
  },
  monthly: {
    marginTop: 4,
    fontSize: 18.7,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 20,
  },

  infoValue: {
    ...Fonts.type.bold,
    fontSize: 17,
  },
  whyText: {
    fontSize: 17,
  },

  breakDownContainer: {
    marginHorizontal: -16,
  },

  breakDownHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 16,
  },

  sectionTitle: {
    fontSize: 17,
    marginVertical: 20,
  },
});
export default style;
